import React from 'react';
import { Heading1 } from '../styled/Heading';
import { StyledHeader } from '../styled/Header';
const logo = require('../resources/icons/logoWithText.svg');

export default function Header({ title }: { title: string }) {
  return (
    <StyledHeader>
      <img style={{ width: '150px' }} src={logo} alt="Statens vegvesen" />
      <Heading1 style={{ color: 'white' }}>{title}</Heading1>
      <aside style={{ width: '150px' }}></aside>
    </StyledHeader>
  );
}
